import { appRoutes } from 'features/app/routes/paths';

export const getStartedPaths = Object.freeze({
    static: {
        root: `${appRoutes.static.root}/get-started`,
        firstStep: `${appRoutes.static.root}/get-started/first-step`,
        secondStep: `${appRoutes.static.root}/get-started/second-step`,
    },
});
